<template>
  <main class="home">
    <VerificationResult
      :icon="`${useAsset('img/credit-line/success_cc.svg')}`"
      :title="titleText"
      :description="descriptionText"
      :btnText="buttonText"
      :error="!successValue"
      @dismissFunc="handleContinueClick"
    />
    <ShippingAddressTestingToolLogs v-if="route.query?.fromDashboard" />
  </main>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useRoute, useRouter } from "vue-router";
import VerificationResult from "@/apps/credit-line/components/Result.vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import { useCreditLineSummary } from "@/apps/credit-line/hooks/useCreditLineSummary";
import { CL_COUNTRY } from "@/apps/credit-line/types/cl_countries";
import ShippingAddressTestingToolLogs from "@/apps/credit-line/components/CreditCard/ShippingAddress/ShippingAddressTestingToolLogs.vue";

export default defineComponent({
  name: "CreditLineResultView",
  components: {
    VerificationResult,
    ShippingAddressTestingToolLogs,
  },
  beforeMount() {
    setLanguage(this);
  },
  setup() {
    const { t } = useI18n();
    const route = useRoute();
    const router = useRouter();
    const { fetchSummary } = useCreditLineSummary();
    const country = ref<CL_COUNTRY | null>(null);
    const successValue = ref<boolean>(true);
    successValue.value = route.query["success"] === "1";
    const titleText = ref<string>("");
    titleText.value = successValue.value
      ? t("PAYJOY_CARD_VIEWS.RESULT_SHIPPING_FORM.CC_ON_THE_WAY")
      : t("PAYJOY_CARD_VIEWS.RESULT_SHIPPING_FORM.ERROR_SOMETHING_GOES_WRONG");
    const descriptionText = ref<string>("");
    descriptionText.value = successValue.value
      ? t("PAYJOY_CARD_VIEWS.RESULT_SHIPPING_FORM.SHOULD_GET_CARD_SOON")
      : t("PAYJOY_CARD_VIEWS.RESULT_SHIPPING_FORM.ERROR_TRY_AGAIN");
    const buttonText = ref<string>("");
    buttonText.value = successValue.value
      ? t("PAYJOY_CARD_VIEWS.RESULT_SHIPPING_FORM.GO_TO_CC_DETAILS")
      : t("PAYJOY_CARD_VIEWS.RESULT_SHIPPING_FORM.TRY_AGAIN");
    const handleContinueClick = () => {
      if (route.query?.fromDashboard) {
        window.close();
      } else {
        if (
          country.value === CL_COUNTRY.MX ||
          country.value === CL_COUNTRY.CO
        ) {
          successValue.value
            ? router.push({ name: "CreditLineDiscoveryView" })
            : router.push({ name: "CreditCardShippingAddressView" });
        } else {
          fetchSummary(true);
          router.push({ name: "CreditCardDetailsView" });
        }
      }
    };
    const getSummary = () => {
      fetchSummary().then((summary) => {
        if (summary) {
          country.value = summary?.country || null;
        }
      });
    };

    onMounted(() => {
      try {
        getSummary();
      } catch (error) {
        console.error("Error getting summary", error);
      }
    });

    return {
      t,
      useAsset,
      route,
      successValue,
      titleText,
      descriptionText,
      buttonText,
      handleContinueClick,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.green {
  color: $pj-color-green;
}
</style>
